<template>
  <div class="page_content">

    <form name="form" id="uploadAlumniInsightZipForm" method="POST" enctype="multipart/form-data" v-on:submit.prevent>

        <div class="hidden-container">
          <input type="file" id="uploadAlumniInsightZipFile" name="file" ref="fileInput" @change="fileToBeUploaded" />
        </div>
        <div class="row page-heading mx-0">
            <div class="col-7 input module_heading" role="heading" aria-level="1">
              <span class="module_icon icon-list"></span>
              <span class="module_type_name">Alumni Insight Bulk Upload</span>
           </div>
            <div class="col-5 submit btn-container text-right">
              <button type="button" class="btn btn-primary" @click.prevent="cancel" aria-label="cancel">cancel</button>
              <button type="button" class="btn btn-primary" @click.prevent="upload" aria-label="upload" :disabled="!file">upload</button>
              <button type="button" class="btn btn-primary" @click.prevent="showDeleteAllConfirm" aria-label="delete all" :disabled="(count === 0) || file">delete all</button>
            </div>
        </div>
        <div>
            <b-row class="mt-5 upload-asset-section">
                <b-col cols="12" class="upload-asset-thru-csv pl-3 pr-3">
                    <div class="card">
                        <div class="heading">Upload Alumni Insights Via a Zip File</div>
                        <div class="thumbnail-section">
                            <span style="font-size: 115px;">
                              <i class="fas fa-file-archive"></i>
                            </span>
                        </div>
                        <div class="card-body text-center">
                            <template v-if="file">
                                <span style="margin-top: -15px;">Chosen File: <strong>{{ file.name }}</strong></span>
                                <button type="button" class="btn btn-primary" @click.stop="chooseFile" aria-label="Change Alumni Insight Zip File" style="bottom: 40px !important;">Change Alumni Insight Zip File</button>
                            </template>
                            <template v-else>
                                <button type="button" class="btn btn-primary" @click.stop="chooseFile" aria-label="Choose Alumni Insight Zip File">Choose Alumni Insight Zip File</button>
                            </template>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>

        <div class="loading-spinner">
          <b-modal style="padding: 0px; overflow: hidden;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
            <div class="text-center" style="color: #FFF; overflow: hidden;">
              <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
            </div>
          </b-modal>
        </div>

    </form>

    <div>
      <b-modal class="delete-folder-popup" ref="deleteAllConfirmModal" no-close-on-backdrop no-close-on-esc centered>
        <div style="text-align: center;">
          <h6>Are you sure you want delete all ({{count}}) Alumni Insights?</h6>
        </div>
        <div slot="modal-header" class="header-section">
          <div class="popup-heading">Please Confirm!</div>
          <button class="btn_close" aria-label="close" @click="cancelDeleteAll">
            <span class="ic-close"></span>
          </button>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-button @click="deleteAll" class="btn button-primary next float-right mr-2" aria-label="ok"> yes </b-button>
          <b-button @click="cancelDeleteAll" class="btn button-primary next float-right mr-2" aria-label="cancel"> no </b-button>
        </div>
      </b-modal>
    </div>

    <div class="loading-spinner">
      <b-modal style="padding: 0px; overflow: hidden;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF; overflow: hidden;">
          <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
        </div>
      </b-modal>
    </div>

  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  var isZipFile = function (file) {
    var fileName = file.name
    var regEx = /(.zip)$/i
    return regEx.test(fileName)
  }

  export default {
    name: 'alumni-insight-bulk-upload',
    data () {
      return {
        count: 0,
        file: undefined
      }
    },
    async beforeMount () {
      this.count = await this.loadDeleteAllAlumniInsightCount()
    },
    methods: {
      ...mapActions([
        'loadBulkUploadAlumniInsight',
        'loadDeleteAllAlumniInsight',
        'loadDeleteAllAlumniInsightCount'
      ]),
      cancel () {
        return this.$router.go(-1)
      },
      chooseFile () {
        let sel = 'id=uploadAlumniInsightZipFile'
        $('input[type=file][' + sel + ']').click()
      },
      fileToBeUploaded (ev) {
        let files = ev.target.files || ev.dataTransfer.files
        if (!files.length) {
          return
        }
        this.file = files[0]
      },
      upload () {
        if (isZipFile(this.file)) {
          this.$refs.loadingModal.show()
          let data = new FormData()
          data.append($('#uploadAlumniInsightZipFile').attr('name'), this.file, this.file.name)
          this.loadBulkUploadAlumniInsight({fileData: data}).then(resp => {
            this.$refs.loadingModal.hide()
            return this.$router.push({ name: 'taskMonitor', params: { taskId: resp.taskId } })
          })
        } else {
          this.clearFilePath()
          this.$notify({
            group: 'notify',
            type: 'error',
            title: '',
            text: 'Please select a Zip file'
          })
        }
      },
      clearFilePath () {
        const input = this.$refs.fileInput
        input.type = 'text'
        input.type = 'file'
      },
      showDeleteAllConfirm () {
        this.$refs.deleteAllConfirmModal.show()
      },
      cancelDeleteAll () {
        this.$refs.deleteAllConfirmModal.hide()
      },
      async deleteAll () {
        this.$refs.deleteAllConfirmModal.hide()
        this.$refs.loadingModal.show()
        let resp = await this.loadDeleteAllAlumniInsight()
        if (resp) {
          let text = this.count + ' Alumni Insights are deleted successfully'
          this.$notify({
            group: 'notify',
            type: 'success',
            title: '',
            text: text
          })
          this.$refs.loadingModal.hide()
        }
        this.count = await this.loadDeleteAllAlumniInsightCount()
      }
    }
  }
</script>

<style scoped>
  .hidden-container{
    visibility: hidden;
    height: 1px;
  }

  .card {
    height: 345px;
    border: 0;
    background: #f5f5f5;
    box-shadow: 2px 1px 6px 0px #b9b9b9;
    border-radius: 0;
    position:relative;
  }

  .card-body {
    margin-top: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/app/programguide/components/AlumniInsightBulkUpload.vue